import styled from "styled-components";

export const DropDownContainer = styled.div`
  margin: 0 auto;
`;

export const DropDownHeader = styled.div`
  display: block;
  width: 180px;
  height: 32px;
  background: #fff;
  border: 2px solid #5c91f5;
  border-radius: 4px;
  text-align: left;
  line-height: 30px;
  padding: 0 16px 0 16px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: #5c91f5;

  cursor: pointer;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DropDownHeaderArrow = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 32px;
  height: 32px;
  background: #5c91f5;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DropDownListContainer = styled.div`
  position: relative;
  z-index: 2;
  padding-top: 4px;
`;

export const DropDownList = styled.ul`
  border: 2px solid #d5d9dd;
  background: #fff;
  width: 180px;
  max-height: 196px;
  overflow-y: auto !important;
  margin: 0;
  padding: 10px 0;
  display: block;
  border-radius: 4px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.08), 0px 10px 16px rgba(0, 0, 0, 0.1);
`;

export const DropDownListItem = styled.li`
  list-style: none;
  display: block;
  margin: 0;
  padding: 10px 20px;
  min-height: 36px;
  line-height: 1.2;
  cursor: pointer;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  color: rgba(0, 27, 59, 0.94);

  &:hover {
    background-color: rgba(0, 27, 59, 0.04);
    color: rgba(0, 27, 59, 0.94);
  }

  ${p => p.isSelected && `
    color: #fff;
    background-color: #5c91f5;
  `}
`;

const Styled = {};

Styled.Body = styled.div`
  width: 100%;
  background: #F5F7FB;
  padding: 40px 40px 70px;
  min-height: calc(100vh - 59px);

  .loader {
    .loader-inner {
      div {
        margin-left: auto;
        margin-right: auto;
        margin-top: 100px;
        border-color: #2a4169;
      }
    }
  }
`;

Styled.SurveyDropDown = styled(DropDownHeader)`
  width: 300px;
`;

Styled.SurveyDropDownList = styled(DropDownList)`
  width: 300px;
`;

Styled.AbsoluteListContainer = styled(DropDownListContainer)`
  position: absolute;
`;

Styled.DownloadLink = styled.a`
  &:active,
  &:visited,
  &:link {
    font-family: 'Mukta Vaani', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 23px;
    text-decoration: underline;
    color: #5C91F5;
  }

  &:hover {
    text-decoration: none;
  }
`;

Styled.Title = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 21px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);

  ${p =>
    p.marginTop &&
    `
    margin-top: ${p.marginTop};
  `}
`;

Styled.Description = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 15px;
`;

Styled.DescriptionText = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  margin-top: 8px;

  span {
    color: rgb(100, 116, 135);
  }
`;

// Two columns: the left column stacks Engagement + Team Insights; the
// right column is a 1fr 1fr grid so Top Performers and Bottom
// Performers sit side-by-side. Both halves of the row share width
// fairly evenly so the right side has room for two compact Performers
// cards. Wraps on narrow viewports.
Styled.Flex = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 20px;
  margin-top: 20px;
  max-width: 1300px;

  > div:first-child {
    flex: 1 1 540px;
    min-width: 0;
  }

  > div:nth-child(2) {
    flex: 1 1 540px;
    min-width: 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    align-items: start;
  }
`;

Styled.Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
  flex-wrap: wrap;
`;

Styled.Block = styled.div`
  width: 370px;
  height: 280px;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${p => !p.isMenuExpanded && `
    width: 418px;
  `}

  ${p => p.twoRowsLength && `
    height: 580px;
  `}

  ${p => p.twoColumnsLength && p.isMenuExpanded && `
    width: 760px;
  `}

  ${p => p.twoColumnsLength && !p.isMenuExpanded && `
    width: 856px;
  `}

  ${p => p.fullWidth && `
    width: 100%;
  `}
`;

// Modern card look (mirrors decisions/product-marketing): single white
// surface with a soft shadow, no dark-blue header bar. The title row
// becomes a flush header inside the card with a thin divider below.
// min-height instead of a fixed height so the Performance Feedback
// block can fit a stacked title + subtitle alongside a search bar
// without clipping.
Styled.BlockTitle = styled.div`
  width: 100%;
  min-height: 48px;
  padding: 10px 16px;
  background: #fff;
  border: 1px solid rgba(0, 27, 59, 0.08);
  border-bottom: 1px solid rgba(0, 27, 59, 0.08);
  border-radius: 8px 8px 0 0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  gap: 12px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

Styled.BlockContent = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid rgba(0, 27, 59, 0.08);
  border-top: none;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  position: relative;
`;

Styled.BlockScroll = styled.div`
  width: 100%;
  height: 100%;
  overflow: auto !important;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #2a4169;
  }
`;

Styled.BlockHint = styled.div`
  position: absolute;
  top: 12px;
  left: 10px;

  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 11.5px;
  line-height: 13px;
  letter-spacing: 1px;
  color: rgba(0, 27, 59, 0.38);
`;

Styled.BlockHintStatus = styled.div`
  position: absolute;
  top: 8px;
  left: 130px;

  display: flex;
  width: 50px;
  height: 20px;
  align-items: center;
  justify-content: center;

  border-radius: 4px;
  border: 1.5px solid #d5d9dd;
  background: #fafafa;

  font-family: Mukta Vaani;
  font-size: 11.5px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  color: rgba(0, 27, 59, 0.38);
`;

Styled.StudentStatsButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 158px;
  height: 32px;
  background: #5c91f5;
  border-radius: 4px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #7ca6f7;
  }
  
  &:disabled {
    border: 1.5px solid #D5D9DD;
    background: #fff;
    color: #001B3B61;

    &:hover {
      background: #fff;
    }
  }
`;

Styled.StudentsErrorContainer = styled.div`
  position: relative;

  .inline-error {
    width: 396px;
    position: absolute;
    bottom: 0;
  }
`;

Styled.Label = styled.p`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #2f4166;
  padding: 50px 0 0 19px;
`;

Styled.Engagement = {};

Styled.Engagement.Columns = styled.div`
  display: flex;
  flex-direction: row;
  gap: 71px;
`;

Styled.Engagement.Title = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.7);

  b {
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    color: rgba(0, 27, 59, 0.94);
  }
`;

Styled.Engagement.Dropdown = styled.div`
  margin-bottom: 10px;
  width: 165px;
  margin-left: -38px;
`;

Styled.Engagement.DropDownHeader = styled(DropDownHeader)`
  width: 165px;
`;

Styled.Engagement.DropDownList = styled(DropDownList)`
  width: 165px;
`;

Styled.Engagement.LeftColumn = styled.div`
  padding: 50px 0 0 19px;
  max-width: 160px;
`;

Styled.Engagement.PercentAmount = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
`;

Styled.Engagement.PercentAmountValue = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 54px;
  line-height: 100%;
  color: #ec5e59;
`;

Styled.Engagement.PercentAmountPercent = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 600;
  font-size: 21px;
  line-height: 100%;
  color: rgba(236, 94, 89, 0.72);
  padding: 19px 0 0 10px;
`;

Styled.Engagement.Description = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #2f4166;
`;

Styled.Engagement.RightColumn = styled.div`
  width: 127px;
  padding-top: 10px;
`;

Styled.Engagement.ChartTitle = styled.div`
  position: absolute;
  top: 4px;
  left: 12px;
  z-index: 1;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.Engagement.Chart = styled.div`
  position: relative;
  width: 127px;
  height: 48px;
  overflow: hidden;

  .recharts-responsive-container {
    margin-top: -6px;
  }

  .recharts-label-list {
    display: none;
  }

  ${p => p.marginTop && `
    margin-top: ${p.marginTop};
  `}
`;

Styled.Performance = {};

Styled.Performance.Columns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 70px;
`;

Styled.Performance.LeftColumn = styled.div`
  padding: 50px 0 0 20px;
`;

Styled.Performance.BigPercentValue = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 54px;
  line-height: 100%;
  color: #72c4cb;
`;

Styled.Performance.PercentLabel = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #2f4166;

  ${p => p.marginTop && `
    margin-top: ${p.marginTop};
  `}
`;

Styled.Performance.SmallPercentValue = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 600;
  font-size: 21px;
  line-height: 140%;
  color: #72c4cb;
`;

Styled.Performance.PercentGroup = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 47px;
  margin-top: 16px;
`;

Styled.Performance.RightColumn = styled.div`
  padding-top: 25.5px;
`;

Styled.Performance.RightTitle = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 600;
  font-size: 21px;
  line-height: 140%;
  color: #2f4166;
  text-align: center;
`;

Styled.Performance.ButtonsGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
  margin-top: 8px;
`;

Styled.Performance.Button = styled.button`
  display: block;
  width: 120px;
  height: 32px;
  background: #fff;
  border: 1.5px solid #2a4169;
  border-radius: 4px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 32px;
  color: #2a4169;
  text-align: center;
  white-space: nowrap;

  &:disabled {
    border-color: #ccc;
    color: #ccc;
    cursor: not-allowed;
    pointer-events: all !important;
  }
`;

Styled.TeamDynamics = {};

Styled.TeamDynamics.WhiteOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  padding-top: 99px;
  padding-left: 37px;
`;

Styled.TeamDynamics.ProcessButton = styled.div`
  display: inline-block;

  width: auto;
  height: 32px;
  background: #5c91f5;
  border-radius: 4px;
  padding: 0 6px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 32px;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-align: center;

  &:hover {
    background-color: #7ca6f7;
  }
`;

Styled.TeamDynamics.UpdateButton = styled.div`
  display: inline-block;
  margin-left: 10px;
  position: relative;
  top: -2px;

  width: 50px;
  height: 20px;
  background: #5c91f5;
  border-radius: 4px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 11.5px;
  line-height: 20px;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
  text-align: center;

  &:hover {
    background-color: #7ca6f7;
  }
`;

Styled.TeamDynamics.Columns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 25px;
`;

Styled.TeamDynamics.LeftColumn = styled.div`
  padding: 8px 0 0 16px;
`;

Styled.TeamDynamics.RightColumn = styled.div`
  margin-top: 43px;
`;

Styled.TeamDynamics.BorderedRight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
  border-right: 1px solid rgba(0, 27, 59, 0.15);
  padding-right: 30px;
`;

Styled.TeamDynamics.LabelsTitle = styled.div`
  font-family: Mukta Vaani;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #2a4169;
  padding-bottom: 11px;
`;

Styled.TeamDynamics.LabelCentered = styled.div`
  font-family: Mukta Vaani;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  color: #2a4169;
  text-align: center;
  padding-top: 88px;
`;

Styled.TeamDynamics.LabelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;
`;

Styled.TeamDynamics.Label = styled.a`
  display: block;

  &:active,
  &:visited,
  &:link {
    font-family: 'Mukta Vaani', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    color: #2f4166;
    text-decoration: none;
  }

  &:hover {
    text-decoration: underline;
  }
`;

Styled.TeamDynamics.LabelIcon = styled.div`
  display: block;
  width: 16px;
  height: 16px;
  border-radius: 100px;

  ${p => p.color && `
    background: ${p.color};
  `}
`;

Styled.TeamDynamics.BubblePanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;

// Wrap the in-block chart area so we can attach the hover handler
// to the charts only (not the header where Update/Search/Download
// live).
Styled.TeamDynamics.ChartHoverArea = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  cursor: zoom-in;
`;

// Hover-popup overlay (full-size design view). Fixed to the
// viewport, dimmed backdrop, centered card.
Styled.TeamDynamics.PopupBackdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  pointer-events: none;
`;

Styled.TeamDynamics.PopupCard = styled.div`
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  padding: 36px 48px 40px;
  width: 900px;
  max-width: 92vw;
  pointer-events: auto;
  font-family: 'Mukta Vaani', sans-serif;
`;

Styled.TeamDynamics.PopupTitle = styled.div`
  font-size: 22px;
  font-weight: 700;
  color: rgba(0, 27, 59, 0.94);
  margin-bottom: 4px;
`;

Styled.TeamDynamics.PopupSubtitle = styled.div`
  font-size: 14px;
  color: rgba(0, 27, 59, 0.55);
  margin-bottom: 20px;
`;

Styled.TeamDynamics.PopupColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 28px;
  align-items: start;
`;

Styled.TeamDynamics.PopupSection = styled.div`
  display: flex;
  flex-direction: column;
`;

Styled.TeamDynamics.PopupSectionLabel = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(0, 27, 59, 0.55);
`;

Styled.TeamDynamics.PopupSectionHint = styled.div`
  font-size: 13px;
  color: rgba(0, 27, 59, 0.6);
  margin-top: 2px;
  margin-bottom: 14px;
`;

Styled.TeamDynamics.PopupChartFrame = styled.div`
  position: relative;
  width: 100%;
  height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

Styled.TeamDynamics.DonutCenter = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-family: 'Mukta Vaani', sans-serif;
  pointer-events: none;
`;

Styled.TeamDynamics.DonutCenterNumber = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: rgba(0, 27, 59, 0.94);
  line-height: 1;
`;

Styled.TeamDynamics.DonutCenterLabel = styled.div`
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(0, 27, 59, 0.55);
  margin-top: 4px;
`;

// Center label rendered inside the donut hole (e.g. "Did Not Work
// Well" stacked across two short lines).
Styled.TeamDynamics.DonutCenterStackedLabel = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 9px;
  font-weight: 700;
  line-height: 11px;
  color: #EC5E59;
  text-align: center;
`;

Styled.TeamDynamics.LegendList = styled.div`
  margin-top: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 16px;
`;

Styled.TeamDynamics.LegendItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: rgba(0, 27, 59, 0.78);
`;

Styled.TeamDynamics.LegendDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${p => p.color || '#ccc'};
`;

Styled.TeamDynamics.LegendName = styled.div`
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

Styled.TeamDynamics.LegendValue = styled.div`
  font-weight: 600;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.TeamDynamics.BubbleSectionHeader = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(0, 27, 59, 0.55);
  padding: 6px 12px 0;
`;

// "Eval: Initial, Final" toggle sitting above the donut, on the same
// horizontal baseline as BubbleSectionHeader.
Styled.TeamDynamics.EvalToggleRow = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(0, 27, 59, 0.55);
  padding: 6px 16px 0;
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 6px;
`;

Styled.TeamDynamics.EvalToggleOption = styled.a`
  cursor: pointer;
  text-decoration: none;
  ${p => p.active && `
    color: #2f4166;
  `}
  ${p => !p.active && `
    color: rgba(0, 27, 59, 0.40);
  `}
  &:hover { text-decoration: underline; }
`;

Styled.TeamDynamics.EvalToggleSeparator = styled.span`
  color: rgba(0, 27, 59, 0.40);
`;

Styled.TeamDynamics.BubbleTabs = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 8px 12px 6px;
  align-items: baseline;
`;

Styled.TeamDynamics.BubbleTab = styled.a`
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 12px;
  line-height: 14px;
  cursor: pointer;
  text-decoration: none;

  ${p => p.active && `
    font-weight: 700;
    color: #2f4166;
  `}
  ${p => !p.active && `
    font-weight: 500;
    color: #7c8aa3;
  `}

  &:hover {
    text-decoration: underline;
  }
`;

Styled.TeamDynamics.BubbleArea = styled.div`
  position: relative;
  flex: 1;
  min-height: 140px;
  padding: 6px 12px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-evenly;
`;

// Wrapper that stacks a bubble + its caption. Sits as a flex item
// inside BubbleArea so space-evenly takes care of even gaps.
Styled.TeamDynamics.BubbleSlot = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-shrink: 0;
`;

// Fixed-height frame around each bubble. By making every slot's
// frame the same height (= MAX_SIZE) and centering the bubble inside,
// bubbles of varying diameters share the same vertical center line.
Styled.TeamDynamics.BubbleFrame = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  ${p => `height: ${p.height}px;`}
`;

Styled.TeamDynamics.BubbleCaption = styled.div`
  margin-top: 6px;
  text-align: center;
  font-family: 'Mukta Vaani', sans-serif;
  width: ${p => p.captionWidth || '70px'};
`;

Styled.TeamDynamics.BubbleCaptionName = styled.div`
  font-size: 10px;
  font-weight: 600;
  color: rgba(0, 27, 59, 0.88);
  line-height: 12px;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

Styled.TeamDynamics.BubbleCaptionCount = styled.div`
  font-size: 9px;
  color: rgba(0, 27, 59, 0.55);
  line-height: 11px;
  margin-top: 2px;
  white-space: nowrap;
`;

Styled.TeamDynamics.Bubble = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  text-align: center;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 11px;
  font-weight: 700;
  line-height: 13px;
  padding: 4px;
  box-sizing: border-box;
  cursor: default;
  flex-shrink: 0;

  ${p => `
    width: ${p.size}px;
    height: ${p.size}px;
    background: ${p.color};
    border: 2px solid ${p.borderColor || p.color};
    color: ${p.textColor || p.borderColor || '#2f4166'};
  `}
`;

Styled.TeamDynamics.BubbleLabel = styled.span`
  display: block;
  width: 100%;
  text-align: center;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  hyphens: auto;
  ${p => p.fontSize && `
    font-size: ${p.fontSize}px;
    line-height: ${Math.max(p.fontSize + 1, 10)}px;
  `}
`;

Styled.SkillSets = {};

Styled.SkillSets.Container = styled.div`
  display: flex;
  padding: 12px;
  height: 100%;
  align-items: center;
  justify-content: center;

  // .recharts-polar-radius-axis .recharts-polar-radius-axis-ticks .recharts-polar-radius-axis-tick:last-child {
  //   display: none;
  // }
`;

Styled.SkillSets.Columns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 21.5px;
`;

Styled.SkillSets.LeftColumn = styled.div`
  padding: 36.5px 0 0 25px;

  .g-recharts-radar-circle {
    text {
      font-family: 'Mukta Vaani', sans-serif;
      font-weight: 500;
      font-size: 13.5px;
      fill: #fff;
    }
  }
`;

Styled.SkillSets.RightColumn = styled.div`
  padding-top: 57px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 16px;
`;

Styled.SkillSets.SkillItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 8px;
`;

Styled.SkillSets.Label = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #2f4166;
`;

Styled.SkillSets.NumCircle = styled.div`
  width: 18px;
  height: 18px;
  background: #667689;
  border-radius: 100px;

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 13.5px;
  line-height: 18px;
  text-align: center;
  color: #fff;

  ${p => p.isActive && `
    background: #eca427;
  `}
`;

Styled.SkillSets.Switcher = styled.div`
  display: flex;
  position: absolute;
  top: 12px;
  right: 10px;
  font-family: 'Roboto';
  font-weight: 500;
  letter-spacing: 1px;
  color: rgba(0, 27, 59, 0.38);
  font-size: 11px;
  line-height: 13px;
`;

Styled.SkillSets.SwitcherItem = styled.button`
  padding: 0;

  &:hover {
    color: rgba(0, 27, 59, 0.94);
  }

  ${p => p.isActive && `
    cursor: default;
    pointer-events: none;
    color: rgba(0, 27, 59, 0.94);
  `}
`;

Styled.SkillSets.SwitcherItemDivider = styled.span`
  padding: 0 6px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.Leaderboard = {};

Styled.Leaderboard.Table = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 362px;
  margin: 20px auto 0;

  ${p => !p.isMenuExpanded && `
    width: 410px;
  `}
`;

Styled.Leaderboard.Row = styled.div`
  height: 54px;
  width: 362px;
  border-top: 1px solid rgba(0, 27, 59, 0.08);
  background: #fff;

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;

  &:nth-child(1), &:nth-child(2) {
    border-top: none;
  }

  ${p => !p.isMenuExpanded && `
    width: 410px;
  `}

  ${p => p.isIndex1 && `
    background-color: #fdd38a;
  `}

  ${p => p.isIndex2 && `
    background-color: #fce0b0;
  `}

  ${p => p.isIndex3 && `
    background-color: #fbedd5;
  `}
`;

Styled.Leaderboard.Loader = styled.div`
  padding: 30px;
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.Leaderboard.SortChar = styled.div`
  display: inline;
  font-size: 12px;
  margin-left: 3px;
`;

Styled.LoadingData = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #fff;
`;

Styled.Leaderboard.Column = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  text-align: center;

  ${p => p.hasShadow && `
    box-shadow: -18px 0px 0px -17px rgba(0, 0, 0, 0.06);
  `}

  ${p => p.hasSort && `
    cursor: pointer;
  `}

  span {
    display: inline-block;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
  }

  display: flex;
  align-items: center;
  justify-content: center;
  height: 54px;

  a:active,
  a:visited,
  a:link {
    font-family: 'Mukta Vaani', sans-serif;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: rgba(0, 27, 59, 0.94);
    text-decoration: underline;
  }

  a:hover {
    text-decoration: none;
  }

  &:nth-child(1) {
    flex-basis: 64px;
    box-shadow: none;
  }

  &:nth-child(2) {
    flex-basis: 128px;
  }

  &:nth-child(3) {
    flex-basis: 90px;
    font-size: 14px;
    line-height: 20px;
  }

  &:nth-child(4) {
    flex-basis: 119px;
  }
`;

// ---------- Performance Feedback block (repurposed Engagement) ----------

// Title row + subtitle stacked inside the existing Styled.BlockTitle
// so the modern card header reads "Performance Feedback / Why Teams
// Didn't Hit Their Targets".
Styled.PerfFeedbackTitleWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

Styled.PerfFeedbackTitle = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.PerfFeedbackSubtitle = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  color: rgba(0, 27, 59, 0.6);
`;

// Body owns the remaining vertical space inside BlockContent. min-height:
// 0 (combined with flex: 1) lets it shrink below its intrinsic content
// size so the long hover text in the detail column doesn't push the
// whole card past its allotted height.
Styled.PerfFeedbackBody = styled.div`
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
  min-height: 0;
`;

// Two-column body: numbered list on the left, hovered/clicked detail
// text on the right. Flex layout (not grid) so each column shares
// the body's height as a hard constraint and the detail column's
// overflow-y: auto can render an actual scrollbar when the hover
// text exceeds the available height.
Styled.PerfFeedbackSplit = styled.div`
  display: flex;
  gap: 24px;
  flex: 1;
  min-height: 0;
  align-items: stretch;
`;

Styled.PerfFeedbackDetailColumn = styled.div`
  flex: 1 1 0;
  min-width: 0;
  min-height: 0;
  border-left: 1px solid rgba(0, 27, 59, 0.08);
  padding: 8px 4px 8px 20px;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.82);
  overflow-y: auto;

  /* Subtle custom scrollbar so the list/detail split stays clean. */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 27, 59, 0.25);
    border-radius: 3px;
  }
`;

Styled.PerfFeedbackDetailPlaceholder = styled.div`
  font-style: italic;
  color: rgba(0, 27, 59, 0.4);
`;

// Search bar lets the instructor type a student or team name to scope
// the feedback list down to that team's reasons. Sized to sit on the
// right side of the BlockTitle header row alongside the title text.
Styled.PerfFeedbackSearch = styled.input`
  width: 280px;
  max-width: 100%;
  padding: 7px 12px;
  border: 1.5px solid #E5E9F0;
  border-radius: 8px;
  background: #F5F7FB;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 13px;
  color: rgba(0, 27, 59, 0.94);
  outline: none;
  transition: border-color 0.15s ease, background 0.15s ease;

  &::placeholder {
    color: rgba(0, 27, 59, 0.45);
  }

  &:focus {
    border-color: #5C91F5;
    background: #FFFFFF;
  }
`;

Styled.PerfFeedbackList = styled.ol`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1 1 0;
  min-width: 0;
`;

Styled.PerfFeedbackItem = styled.li`
  display: grid;
  grid-template-columns: 24px 1fr;
  align-items: baseline;
  gap: 8px;
  padding: 6px 6px;
  border-bottom: 1px solid rgba(0, 27, 59, 0.06);

  font-family: 'Mukta Vaani', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);

  &:last-child { border-bottom: none; }
`;

Styled.PerfFeedbackNumber = styled.span`
  font-weight: 700;
  color: rgba(0, 27, 59, 0.5);
`;

// Inline error shown when the instructor submits a team-name search
// that doesn't match any team in the round.
Styled.PerfFeedbackNotFound = styled.div`
  padding: 16px 6px 8px;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: #DC2626;
`;

// Tooltip used to surface the long-form hovering popup message on
// each Performance Feedback list row. CSS-only — the parent wrapper
// uses :hover to toggle visibility, so no JS state needed.
Styled.PerfFeedbackTooltipWrap = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 6px;

  &:hover .pf-tooltip {
    visibility: visible;
    opacity: 1;
    transform: translateY(0);
  }
`;

Styled.PerfFeedbackInfoIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgba(0, 27, 59, 0.12);
  color: rgba(0, 27, 59, 0.7);
  font-size: 10px;
  font-weight: 700;
  font-style: italic;
  cursor: help;
  flex-shrink: 0;
  user-select: none;
`;

Styled.PerfFeedbackTooltip = styled.span.attrs({ className: 'pf-tooltip' })`
  position: absolute;
  bottom: calc(100% + 8px);
  left: -8px;
  z-index: 20;

  width: 320px;
  max-width: 320px;
  padding: 10px 14px;
  background: rgba(0, 27, 59, 0.96);
  color: #ffffff;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 12.5px;
  font-weight: 500;
  line-height: 17px;
  letter-spacing: 0;
  text-transform: none;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
  white-space: normal;

  visibility: hidden;
  opacity: 0;
  transform: translateY(4px);
  transition: opacity 0.15s ease, transform 0.15s ease, visibility 0.15s ease;
  pointer-events: none;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 18px;
    border: 5px solid transparent;
    border-top-color: rgba(0, 27, 59, 0.96);
  }
`;

// ---------- Modern KPI tiles (mirror /decisions/product-marketing) ----------

// Top-of-dashboard row of small KPI cards. Three equal columns; wraps
// to a 2-column grid on narrow viewports so it never overflows the
// dashboard width.
Styled.KpiRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 20px;
  margin-bottom: 4px;
  max-width: 1300px;

  @media (max-width: 1280px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 640px) {
    grid-template-columns: 1fr;
  }
`;

Styled.KpiCard = styled.div`
  background: #fff;
  border-radius: 8px;
  padding: 16px 18px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 96px;
`;

Styled.KpiLabel = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: rgba(0, 27, 59, 0.6);
`;

// Header row that holds the KPI label on the left and a small "view
// details" link on the right, on the same baseline. Used at the top
// of each KpiCard so the link no longer needs its own bottom row.
Styled.KpiHeader = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 12px;
`;

Styled.KpiValueRow = styled.div`
  display: flex;
  align-items: baseline;
  gap: 18px;
  flex-wrap: wrap;
`;

Styled.KpiValue = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 24px;
  line-height: 30px;
  color: rgba(0, 27, 59, 0.94);
`;

// Smaller label+value pair used inside the Team Scores tile. Label and
// value sit on the same row (label left, value right) with a small gap.
Styled.KpiMicroPair = styled.div`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  gap: 8px;
`;

Styled.KpiMicroLabel = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 11.5px;
  line-height: 14px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(0, 27, 59, 0.5);
`;

Styled.KpiMicroValue = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 28px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.KpiLink = styled.a`
  &:active,
  &:visited,
  &:link {
    font-family: 'Mukta Vaani', sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 18px;
    text-decoration: underline;
    color: #5C91F5;
    cursor: pointer;
    white-space: nowrap;
  }

  &:hover {
    text-decoration: none;
  }
`;

// Disabled variant of KpiLink used when the target page has nothing
// to show yet (e.g. Team Scores before any round has finished). The
// wrapper hosts a hover tooltip so the instructor knows why the link
// isn't clickable.
Styled.KpiLinkDisabledTip = styled.span`
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.12s ease;
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  z-index: 10;
  background: rgba(0, 27, 59, 0.94);
  color: #ffffff;
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  padding: 10px 14px;
  border-radius: 6px;
  white-space: nowrap;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  pointer-events: none;
`;

Styled.KpiLinkDisabledWrap = styled.span`
  position: relative;
  display: inline-block;

  &:hover ${Styled.KpiLinkDisabledTip} {
    visibility: visible;
    opacity: 1;
  }
`;

Styled.KpiLinkDisabled = styled.span`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 18px;
  text-decoration: underline;
  color: rgba(0, 27, 59, 0.35);
  cursor: not-allowed;
  white-space: nowrap;
`;

// ---------- Top / Bottom Performers compact cards ----------
//
// A single white card per block (no separated header strip). The
// title sits at the top of the body, followed by the column headers
// and rows. Two of these stack vertically in the right column next
// to the Engagement + Team Insights stack on the left.

// Min-height matches the left column's stacked Engagement (280px) +
// Row gap (20px) + Team Insights (280px) = 580px so the bottoms of
// both columns align at the same y-position.
Styled.PerformersBlock = styled.div`
  width: 100%;
  min-height: 580px;
  background: #fff;
  border: 1px solid rgba(0, 27, 59, 0.08);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  padding: 18px 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

// ---- Student Spotlight (combined Top + Bottom Performers) ----
Styled.SpotlightBlock = styled.div`
  width: 100%;
  min-height: 580px;
  background: #fff;
  border: 1px solid rgba(0, 27, 59, 0.08);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  padding: 18px 18px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  grid-column: 1 / -1;
`;

Styled.SpotlightHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.SpotlightHeaderLeft = styled.div`
  display: flex;
  align-items: baseline;
  gap: 14px;
  flex-wrap: wrap;
  min-width: 0;
`;

Styled.SpotlightDescription = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 13px;
  line-height: 19px;
  color: rgba(0, 27, 59, 0.55);
  margin-top: -4px;
  max-width: 720px;
`;

Styled.SpotlightColumns = styled.div`
  display: grid;
  grid-template-columns: 1fr 1px 1fr;
  gap: 24px;
  align-items: start;
  flex: 1;
  min-height: 0;
`;

Styled.SpotlightDivider = styled.div`
  background: rgba(0, 27, 59, 0.10);
  width: 1px;
  align-self: stretch;
`;

Styled.SpotlightColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 0;
`;

Styled.SpotlightSubheader = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.04em;
  color: rgba(0, 27, 59, 0.78);
  text-transform: uppercase;
`;

// Centered empty/state element that spans both Spotlight columns
// (used for the "no peer evaluation" message and the Generate
// Insights button).
Styled.SpotlightEmptyState = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  text-align: center;
  font-family: 'Mukta Vaani', sans-serif;
`;

Styled.SpotlightEmptyMessage = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.65);
  max-width: 460px;
`;

Styled.SpotlightGenerateButton = styled.button`
  margin-top: 20px;
  padding: 12px 28px;
  background: #3258F5;
  color: #fff;
  border: 0;
  border-radius: 28px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover { background: #2545cc; }

  &:disabled {
    background: rgba(0, 27, 59, 0.18);
    color: rgba(0, 27, 59, 0.55);
    cursor: not-allowed;
  }
  &:disabled:hover { background: rgba(0, 27, 59, 0.18); }
`;

Styled.SpotlightNotice = styled.div`
  margin-top: 20px;
  padding: 12px 18px;
  background: #DBEAFE;
  border-radius: 10px;
  font-family: inherit;
  font-size: 13px;
  line-height: 19px;
  color: #1D4ED8;
  font-weight: 500;
  max-width: 480px;
`;

// ---- Generate-insights confirmation popup ----
Styled.SpotlightConfirm = {};

Styled.SpotlightConfirm.Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 41, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1300;
  font-family: 'Mukta Vaani', sans-serif;
`;

Styled.SpotlightConfirm.Card = styled.div`
  width: 440px;
  max-width: 92vw;
  background: #fff;
  border-radius: 14px;
  padding: 28px 28px 22px;
  box-shadow: 0 24px 70px rgba(15, 23, 41, 0.28);
`;

Styled.SpotlightConfirm.Title = styled.div`
  font-size: 19px;
  font-weight: 800;
  color: rgba(0, 27, 59, 0.94);
  margin-bottom: 10px;
`;

Styled.SpotlightConfirm.Body = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.78);
  margin-bottom: 22px;
`;

Styled.SpotlightConfirm.Actions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;

Styled.SpotlightConfirm.CancelButton = styled.button`
  padding: 10px 18px;
  background: #fff;
  color: rgba(0, 27, 59, 0.78);
  border: 1px solid #E5E9F0;
  border-radius: 22px;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  &:hover { background: #F8FAFD; color: rgba(0, 27, 59, 0.94); }
`;

Styled.SpotlightConfirm.ConfirmButton = styled.button`
  padding: 10px 20px;
  background: #3258F5;
  color: #fff;
  border: 0;
  border-radius: 22px;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  &:hover { background: #2545cc; }
`;

Styled.PerformersTitle = styled.div`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  color: rgba(0, 27, 59, 0.94);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

Styled.PerformersRoundHint = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 11.5px;
  line-height: 13px;
  letter-spacing: 1px;
  color: rgba(0, 27, 59, 0.38);
`;

Styled.PerformersHeaderRow = styled.div`
  display: grid;
  grid-template-columns: 44px 60px 1fr;
  gap: 8px;
  align-items: center;
  padding: 6px 2px;
  border-bottom: 1px solid rgba(0, 27, 59, 0.08);

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: rgba(0, 27, 59, 0.5);
`;

Styled.PerformersBodyRow = styled.div`
  display: grid;
  grid-template-columns: 44px 60px 1fr;
  gap: 8px;
  align-items: center;
  padding: 8px 2px;
  border-bottom: 1px solid rgba(0, 27, 59, 0.04);

  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 27, 59, 0.94);

  &:last-child {
    border-bottom: none;
  }
`;

// Chip rendered in the Team column of the Student Spotlight rows.
// Shows the full team name (e.g. "AA02", "FA06") so instructors can
// tell apart different teams that share a section prefix. Width is
// sized for the current <section><number> convention (4 chars) with
// a bit of breathing room; longer names are truncated with ellipsis
// and the full value stays reachable via the parent cell's title.
Styled.SpotlightTeamBadge = styled.div`
  width: 52px;
  height: 24px;
  border-radius: 6px;
  background: #F3F4F6;
  border: 1px solid #E5E7EB;
  color: #374151;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

// Filter-by-team control in the Student Spotlight header. Behaves
// like a text-input shell that opens a floating multi-select menu
// on click. Teams listed are the ones present in the current MVP+LVP
// data, which is already section-scoped by the backend.
Styled.SpotlightFilter = {};

Styled.SpotlightFilter.Wrap = styled.div`
  position: relative;
  flex-shrink: 0;
`;

Styled.SpotlightFilter.Button = styled.button`
  background: #fff;
  border: 1px solid rgba(0, 27, 59, 0.18);
  border-radius: 8px;
  padding: 8px 36px 8px 14px;
  min-width: 220px;
  text-align: left;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: ${p => (p.hasSelection ? 'rgba(0, 27, 59, 0.94)' : 'rgba(0, 27, 59, 0.5)')};
  cursor: pointer;
  position: relative;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &:hover:not(:disabled) {
    border-color: rgba(0, 27, 59, 0.35);
  }

  &:focus {
    outline: none;
    border-color: #3A507B;
    box-shadow: 0 0 0 3px rgba(58, 80, 123, 0.14);
  }
`;

Styled.SpotlightFilter.Chevron = styled.span`
  position: absolute;
  right: 12px;
  top: 50%;
  width: 8px;
  height: 8px;
  border-right: 1.5px solid rgba(0, 27, 59, 0.4);
  border-bottom: 1.5px solid rgba(0, 27, 59, 0.4);
  transform: translateY(-70%) rotate(45deg);
  pointer-events: none;
`;

Styled.SpotlightFilter.Dropdown = styled.div`
  position: absolute;
  top: calc(100% + 6px);
  right: 0;
  min-width: 240px;
  max-height: 280px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid rgba(0, 27, 59, 0.14);
  border-radius: 8px;
  box-shadow: 0 10px 28px rgba(0, 27, 59, 0.14);
  z-index: 50;
  padding: 6px 0;
`;

Styled.SpotlightFilter.Option = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 14px;
  color: rgba(0, 27, 59, 0.94);
  cursor: pointer;

  &:hover {
    background: rgba(58, 80, 123, 0.06);
  }

  input {
    margin: 0;
    cursor: pointer;
  }
`;

Styled.SpotlightFilter.Empty = styled.div`
  padding: 10px 14px;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 13px;
  color: rgba(0, 27, 59, 0.5);
`;

Styled.SpotlightFilter.Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 6px 10px 4px;
  border-top: 1px solid rgba(0, 27, 59, 0.08);
  margin-top: 4px;
`;

Styled.SpotlightFilter.Clear = styled.button`
  background: none;
  border: none;
  font-family: 'Mukta Vaani', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(0, 27, 59, 0.6);
  cursor: pointer;
  padding: 4px 6px;

  &:hover:not(:disabled) {
    color: rgba(0, 27, 59, 0.94);
    text-decoration: underline;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

// Scrollable list container for the Performers blocks. Caps the
// visible rows so that lists longer than 10 entries surface a
// vertical scrollbar inside the block instead of stretching the
// card itself.
Styled.PerformersScroll = styled.div`
  overflow-y: auto;
  max-height: 460px;

  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 27, 59, 0.25);
    border-radius: 3px;
  }
`;

// Inline tagline next to the Performers block title (e.g.
// "Top Performers (most valuable players)").
Styled.PerformersSubtitle = styled.span`
  font-family: 'Mukta Vaani', sans-serif;
  font-weight: 500;
  font-size: 13px;
  color: rgba(0, 27, 59, 0.6);
  margin-left: 6px;
`;

Styled.PerformersCell = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

// "(Skills Certificate)" link next to each Top Performer name.
Styled.SkillsCertificateLink = styled.a`
  margin-left: 6px;
  color: rgba(50, 88, 245, 0.85);
  font-size: 12px;
  font-weight: 500;
  text-decoration: none;
  cursor: pointer;
  &:hover { text-decoration: underline; }
`;

// =================================================================
// Areas of Improvement (Insights) popup — Bottom Performer rows
// =================================================================

Styled.Insights = {};

Styled.Insights.Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  /* Above every other dashboard overlay (TeamLookup 1200,
     SpotlightConfirm 1300, badges tour/review 1500-1900) so the
     Insights popup for a Least Valuable teammate can't get covered
     by the Student Spotlight card behind it. Same layer as the
     Skills Badge popup (2000) since they're triggered from adjacent
     rows in the same card. */
  z-index: 2000;
`;

Styled.Insights.Card = styled.div`
  background: #fff;
  border-radius: 14px;
  width: 680px;
  max-width: 92vw;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 22px 70px rgba(0, 0, 0, 0.28);
  font-family: 'Mukta Vaani', sans-serif;
  position: relative;
`;

Styled.Insights.CloseButton = styled.button`
  position: absolute;
  top: 14px;
  right: 18px;
  z-index: 5;
  background: none;
  border: 0;
  color: rgba(0, 27, 59, 0.55);
  font-size: 26px;
  line-height: 1;
  cursor: pointer;
  &:hover { color: rgba(0, 27, 59, 0.94); }
`;

Styled.Insights.Header = styled.div`
  padding: 28px 36px 0;
`;

Styled.Insights.Eyebrow = styled.div`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #EC5E59;
`;

Styled.Insights.Title = styled.div`
  margin-top: 6px;
  font-size: 24px;
  font-weight: 800;
  color: rgba(0, 27, 59, 0.94);
`;

Styled.Insights.Subtitle = styled.div`
  margin-top: 4px;
  font-size: 14px;
  color: rgba(0, 27, 59, 0.55);
`;

Styled.Insights.Body = styled.div`
  padding: 22px 36px 32px;
  overflow-y: auto;
`;

Styled.Insights.SectionLabel = styled.div`
  margin-top: 18px;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 700;
  color: rgba(0, 27, 59, 0.94);
  &:first-child { margin-top: 0; }
`;

Styled.Insights.Paragraph = styled.div`
  font-size: 14px;
  line-height: 22px;
  color: rgba(0, 27, 59, 0.78);
`;

Styled.Insights.EvidenceList = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

Styled.Insights.EvidenceItem = styled.div`
  padding-left: 14px;
  border-left: 4px solid #EC5E59;
  font-size: 14px;
  line-height: 22px;
  font-style: italic;
  color: rgba(0, 27, 59, 0.78);
`;

Styled.Insights.EvidenceSkill = styled.div`
  font-style: normal;
  font-weight: 600;
  color: rgba(0, 27, 59, 0.65);
  margin-top: 4px;
  font-size: 12px;
`;

Styled.Insights.Empty = styled.div`
  font-size: 14px;
  color: rgba(0, 27, 59, 0.55);
  font-style: italic;
`;

// =================================================================
// Team Lookup — KPI-row "Look up a team" card + modal
// =================================================================

Styled.TeamLookup = {};

// ---- Card (sits on the KPI row alongside Team Scores / Count) ----
Styled.TeamLookup.Card = styled.button`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 10px;
  padding: 18px 20px;
  background: #fff;
  border: 1px solid #E5E9F0;
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  width: 100%;
  text-align: left;
  cursor: pointer;
  font-family: 'Mukta Vaani', sans-serif;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(37, 99, 235, 0.10);
    border-color: rgba(37, 99, 235, 0.45);
  }
  &:focus {
    outline: 2px solid rgba(37, 99, 235, 0.45);
    outline-offset: 2px;
  }
`;

Styled.TeamLookup.CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  color: #0F1729;
`;

Styled.TeamLookup.CardIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: #DBEAFE;
  color: #2563EB;
  font-size: 12px;
`;

Styled.TeamLookup.CardShortcut = styled.span`
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  border: 1px solid #E5E9F0;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #4B5563;
  background: #F8FAFD;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
`;

Styled.TeamLookup.CardInputMock = styled.div`
  padding: 9px 12px;
  border: 1px solid #E5E9F0;
  border-radius: 8px;
  background: #F8FAFD;
  font-size: 13px;
  color: rgba(15, 23, 41, 0.42);
`;

Styled.TeamLookup.CardHelper = styled.div`
  font-size: 12px;
  color: #4B5563;
`;

// ---- Modal ----
Styled.TeamLookup.Backdrop = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 41, 0.6);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  z-index: 1200;
  padding-top: 80px;
`;

Styled.TeamLookup.Card2 = styled.div`
  width: 580px;
  max-width: 92vw;
  max-height: 76vh;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 24px 70px rgba(15, 23, 41, 0.28);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: 'Mukta Vaani', sans-serif;
  color: #0F1729;

  @media (max-width: 600px) {
    width: 96vw;
  }
`;

Styled.TeamLookup.SearchRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  border-bottom: 1px solid #E5E9F0;
`;

Styled.TeamLookup.SearchIcon = styled.span`
  font-size: 16px;
  color: #4B5563;
`;

Styled.TeamLookup.SearchInput = styled.input`
  flex: 1;
  border: 0;
  outline: 0;
  background: transparent;
  font: inherit;
  font-size: 16px;
  color: #0F1729;
  &::placeholder { color: rgba(15, 23, 41, 0.45); }
`;

Styled.TeamLookup.CloseIcon = styled.button`
  border: 0;
  background: none;
  font-size: 22px;
  line-height: 1;
  color: #4B5563;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;
  &:hover { background: #F1F4FA; color: #0F1729; }
`;

Styled.TeamLookup.List = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 6px;
`;

Styled.TeamLookup.SectionHeader = styled.div`
  padding: 14px 14px 8px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(15, 23, 41, 0.45);
`;

Styled.TeamLookup.SectionHeaderCount = styled.span`
  color: rgba(15, 23, 41, 0.78);
`;

Styled.TeamLookup.Row = styled.div`
  display: grid;
  grid-template-columns: 36px 1fr auto;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  ${p => p.highlighted && `
    background: #DBEAFE;
  `}
  &:hover { background: #DBEAFE; }
`;

Styled.TeamLookup.Avatar = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #DBEAFE 0%, #BFDBFE 100%);
  color: #1D4ED8;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
`;

Styled.TeamLookup.RowText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

Styled.TeamLookup.RowName = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #0F1729;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

Styled.TeamLookup.RowMeta = styled.div`
  font-size: 12px;
  color: #4B5563;
`;

Styled.TeamLookup.RowScore = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  font-family: 'Mukta Vaani', sans-serif;
`;

Styled.TeamLookup.RowScoreValue = styled.div`
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
  color: ${p => (p.value == null ? '#9CA3AF' : '#0F1729')};
`;

Styled.TeamLookup.RowScoreLabel = styled.div`
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: rgba(15, 23, 41, 0.45);
`;

Styled.TeamLookup.Empty = styled.div`
  padding: 28px 16px;
  text-align: center;
  color: #4B5563;
  font-size: 13px;
`;

Styled.TeamLookup.Footer = styled.div`
  padding: 10px 16px;
  border-top: 1px solid #E5E9F0;
  display: flex;
  justify-content: space-between;
  font-size: 11.5px;
  color: #4B5563;
`;

Styled.TeamLookup.HintKey = styled.span`
  padding: 1px 6px;
  border: 1px solid #E5E9F0;
  border-radius: 4px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11px;
  color: #4B5563;
  background: #F8FAFD;
  margin-right: 4px;
`;

// ---- Step 2 (action sheet) ----
Styled.TeamLookup.SelectedBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
  border-bottom: 1px solid #E5E9F0;
`;

Styled.TeamLookup.ChangeTeamButton = styled.button`
  margin-left: auto;
  background: none;
  border: 1px solid #E5E9F0;
  border-radius: 8px;
  padding: 6px 12px;
  font: inherit;
  font-size: 12.5px;
  font-weight: 600;
  color: #4B5563;
  cursor: pointer;
  &:hover { background: #F1F4FA; color: #0F1729; }
`;

Styled.TeamLookup.ActionsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  padding: 18px;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

Styled.TeamLookup.ActionButton = styled.button`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 18px;
  border-radius: 10px;
  border: 1.5px solid transparent;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  transition: transform 0.15s ease, box-shadow 0.15s ease, border-color 0.15s ease;

  ${p => p.variant === "audit" && `
    background: #EDE9FE;
    border-color: rgba(124, 58, 237, 0.25);
    color: #5B21B6;
  `}
  ${p => p.variant === "report" && `
    background: #D1FAE5;
    border-color: rgba(5, 150, 105, 0.25);
    color: #065F46;
  `}

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(15, 23, 41, 0.10);
    ${p => p.variant === "audit" && `border-color: #7C3AED;`}
    ${p => p.variant === "report" && `border-color: #059669;`}
  }
`;

Styled.TeamLookup.ActionTitle = styled.div`
  font-size: 15px;
  font-weight: 800;
`;

Styled.TeamLookup.ActionBlurb = styled.div`
  font-size: 12.5px;
  line-height: 18px;
  color: rgba(15, 23, 41, 0.65);
`;

export default Styled;



// WEBPACK FOOTER //
// ./src/instructor/styles/dashboard.js